import { Injectable } from '@angular/core';
import { DialogService, DialogRef, DialogResult } from '@progress/kendo-angular-dialog';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NotificationDialogService {
  constructor(private dialogService: DialogService) { }

  openNotificationDialog(title: string, content: string) {
    const dialogRef = this.dialogService.open({
      title
      , content
      , actions: [{ text: 'Ok', value: true, themeColor: 'primary' }]
      , width: 450
      , height: 200
      , minWidth: 250
      , cssClass: 'isg-dialog-editor'
    });
    dialogRef.result.subscribe((result) => {
      if (result !== undefined) {
        // Close the dialog when a button is clicked
        dialogRef.close();
      }
    });


  }
}
